"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentData = void 0;
const lodash_1 = __importDefault(require("lodash"));
const Assignment_1 = require("./Assignment");
var AssignmentData;
(function (AssignmentData) {
    function from(assignments, metas) {
        const assignmentMap = lodash_1.default.keyBy(assignments, (a) => a._id);
        const results = metas.map((meta) => {
            const assignment = assignmentMap[meta._id];
            return assignment && { assignment, meta };
        });
        return lodash_1.default.compact(results);
    }
    AssignmentData.from = from;
    function fromComplete(complete) {
        return {
            assignment: Assignment_1.Assignment.from(complete.content, complete.settings),
            meta: complete.meta,
        };
    }
    AssignmentData.fromComplete = fromComplete;
    function isTest(data) {
        return Assignment_1.Assignment.isTest(data.assignment);
    }
    AssignmentData.isTest = isTest;
    function isHomework(data) {
        return Assignment_1.Assignment.isHomework(data.assignment);
    }
    AssignmentData.isHomework = isHomework;
    function isRealtime(data) {
        return Assignment_1.Assignment.isRealtime(data.assignment);
    }
    AssignmentData.isRealtime = isRealtime;
})(AssignmentData || (exports.AssignmentData = AssignmentData = {}));
//# sourceMappingURL=AssignmentData.js.map